/**
 * Centralized terminology per shop type (vehicles vs motorcycles).
 * Single source of truth for "Vehículo"/"Motocicleta" wording across the UI.
 * Mirror of backend/src/utils/terms.js — keep both in sync.
 */
export const TERMS = {
  vehicles: {
    singular: 'Vehículo',
    plural: 'Vehículos',
    singularLower: 'vehículo',
    pluralLower: 'vehículos',
    new: 'Nuevo Vehículo',
    article: 'el vehículo',
    my: 'su vehículo',
    ofThe: 'del', // "Información del Vehículo"
    exampleBrand: 'Toyota',
    exampleModel: 'Corolla',
    examplePlate: 'P 123-456',
  },
  motorcycles: {
    singular: 'Motocicleta',
    plural: 'Motocicletas',
    singularLower: 'motocicleta',
    pluralLower: 'motocicletas',
    new: 'Nueva Motocicleta',
    article: 'la motocicleta',
    my: 'su motocicleta',
    ofThe: 'de la', // "Información de la Motocicleta"
    exampleBrand: 'Honda',
    exampleModel: 'CB125F',
    examplePlate: 'M 123-456',
  },
};

/**
 * Get a localized term for a given shop type.
 * @param {string} key - singular | plural | singularLower | pluralLower | new | article | my
 * @param {string} shopType - 'vehicles' | 'motorcycles'
 */
export const getTerm = (key, shopType = 'vehicles') => {
  const map = TERMS[shopType] || TERMS.vehicles;
  return map[key] ?? key;
};

export default { TERMS, getTerm };
